import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_TOKEN = "rh_admin_token";
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem(ADMIN_TOKEN);
  if (t && (c.url.startsWith("/admin") || c.url.startsWith("/auth"))) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const img = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (typeof d?.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d))).join(" ");
  return detail.msg || String(detail);
}

export const firstAvailable = (p) => (p?.variants?.length ? (p.variants.find((v) => v.stock > 0) || p.variants[0]).label : "");

export const load = (k, d) => {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? d;
  } catch {
    return d;
  }
};

export const STATUS = {
  awaiting_payment: { label: "Awaiting payment", cls: "bg-[#FBEFD9] text-[#7A5310]" },
  under_verification: { label: "Under verification", cls: "bg-[#E3E9F5] text-[#344E82]" },
  paid: { label: "Paid", cls: "bg-[#DDEDE6] text-[#276653]" },
  processing: { label: "Processing", cls: "bg-[#EDE6F3] text-[#5B3E78]" },
  shipped: { label: "Shipped", cls: "bg-[#EDE6F3] text-[#5B3E78]" },
  delivered: { label: "Delivered", cls: "bg-[#DDEDE6] text-[#276653]" },
  cancelled: { label: "Cancelled", cls: "bg-[#ECE8E8] text-[#5E5358]" },
  rejected: { label: "Rejected", cls: "bg-[#F6DDE2] text-[#A9344D]" },
  refunded: { label: "Refunded", cls: "bg-[#F3E6E6] text-[#77384E]" },
};

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || { label: status, cls: "bg-pearl" };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-lg px-2.5 py-1 text-[12px] font-bold tracking-wide ${s.cls}`}>
      {s.label}
    </span>
  );
};
